import qs from 'qs';
import oikosApi from '../../../services/oikos';

const toIsoDate = (value) => {
  const match = String(value || '').match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : null;
};

export const fetchProjetoDoOrcItem = async (orcItemId) => {
  const id = Number(orcItemId) || 0;
  if (!id) return null;

  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'orcItem',
    data: { orcItem_id: id },
    fields: {
      '(SELECT proj_id FROM proj WHERE proj.orcRubr_id = (SELECT orcRubr_mae FROM orcRubr WHERE orcRubr.orcRubr_id = orcItem.orcRubr_id LIMIT 1) LIMIT 1)': 'proj_id',
      '(SELECT proj_nome FROM proj WHERE proj.orcRubr_id = (SELECT orcRubr_mae FROM orcRubr WHERE orcRubr.orcRubr_id = orcItem.orcRubr_id LIMIT 1) LIMIT 1)': 'proj_nome',
      '(SELECT contrato_prazoVigencia FROM contrato WHERE contrato.contrato_id = (SELECT contrato_id FROM proj WHERE proj.orcRubr_id = (SELECT orcRubr_mae FROM orcRubr WHERE orcRubr.orcRubr_id = orcItem.orcRubr_id LIMIT 1) LIMIT 1) LIMIT 1)': 'contrato_prazoVigencia',
      '(SELECT contrato_prazoVigencia FROM contrato WHERE contrato.contrato_original = (SELECT contrato_id FROM proj WHERE proj.orcRubr_id = (SELECT orcRubr_mae FROM orcRubr WHERE orcRubr.orcRubr_id = orcItem.orcRubr_id LIMIT 1) LIMIT 1) AND contrato_prazoVigencia IS NOT NULL ORDER BY contrato_dtAssin DESC, contrato_id DESC LIMIT 1)': 'contrato_prazoVigenciaAditivo',
    },
  })}`);

  const row = res?.data?.[0] || {};
  if (!(Number(row.proj_id) > 0)) return null;

  return {
    proj_id: Number(row.proj_id),
    proj_nome: String(row.proj_nome || '').trim(),
    prazo: toIsoDate(row.contrato_prazoVigenciaAditivo) || toIsoDate(row.contrato_prazoVigencia),
  };
};
